import { useQuery } from '@tanstack/react-query'
import { getShiftLeadEligibility } from 'api/shift'
import { QueryFnParams, QueryOptions } from 'queries/types'
import { shiftLeadEligibilityKey } from './keys'

export function useShiftLeadEligibility(
  params: Partial<QueryFnParams<typeof getShiftLeadEligibility>[0]>,
  options: QueryOptions<typeof getShiftLeadEligibility> = {}
) {
  const { companyId } = params

  return useQuery({
    ...options,
    queryKey: shiftLeadEligibilityKey(companyId),
    queryFn: ({ signal }) => {
      if (!companyId) {
        throw new Error('Company is required')
      }
      return getShiftLeadEligibility({ companyId }, signal)
    },
    enabled: !!companyId && (options.enabled ?? true),
  })
}
